export const createPaginationSlice = (set, get) => ({
    page: 1,
    limit: 20,
    total: 0,

    setPage: (page) => set({ page }),
    setLimit: (limit) => set({ limit, page: 1 }),
    setTotal: (total) => set({ total }),

    nextPage: () => {
        const { page, limit, total } = get();
        const maxPage = Math.ceil(total / limit);
        if (page < maxPage) set({ page: page + 1 });
    },

    prevPage: () => {
        const { page } = get();
        if (page > 1) set({ page: page - 1 });
    },

    resetPagination: () => set({ page: 1, limit: 20, total: 0 }),
});
